/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Document_ReclassifiedInputs */

const en_case_history_headline_document_reclassified = /** @type {(inputs: Case_History_Headline_Document_ReclassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File reclassified`)
};

const pt_br2_case_history_headline_document_reclassified = /** @type {(inputs: Case_History_Headline_Document_ReclassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo reclassificado`)
};

/**
* | output |
* | --- |
* | "File reclassified" |
*
* @param {Case_History_Headline_Document_ReclassifiedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_document_reclassified = /** @type {((inputs?: Case_History_Headline_Document_ReclassifiedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Document_ReclassifiedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_document_reclassified(inputs)
	return pt_br2_case_history_headline_document_reclassified(inputs)
});